import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';

interface GenerateReportFailureProps {
  onClose: () => void;
  isOpen: boolean;
}

const GenerateReportFailure = ({ onClose, isOpen }: GenerateReportFailureProps) => {
  return (
    <ModalWrappedContent isOpen={isOpen} onClose={onClose} showCancelButton={false}>
      <ModalTitle>Report Generation Failed</ModalTitle>
      <ModalBody>
        <Text>We’re sorry. This process did not complete.</Text>
      </ModalBody>
    </ModalWrappedContent>
  );
};

export default GenerateReportFailure;

const ModalTitle = styled.div`
  color: ${themeVar('font.strong')};
  text-align: center;
  font-size: 33px;
  font-weight: 400;
  line-height: 46.2px;
  margin: 40px 0 10px 0;
`;

const ModalBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  margin-bottom: 40px;
`;

const Text = styled.p`
  color: ${themeVar('font.base')};
  font-size: 19px;
  font-weight: 400;
  line-height: 26.6px;
`;
